import Constant from '@/const';
import axios from 'axios';

const putSupplier = async (id, payload) => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/master/supplier/${id}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putSupplier;
